module.exports = __webpack_public_path__ + "static/team-5-67572b91109bde90ab12ad0cc9d2e509.jpg";